// For ES Module via npm/yarn, or with import maps
import Appsignal from "@appsignal/javascript";
import { plugin } from "@appsignal/plugin-window-events"
 
export const appsignal = new Appsignal({
  key: "1d24e969-6613-4d42-9092-002c6fbb79cc",
});

appsignal.use(plugin({}))